import { cn } from '@cobliteam/ui/utils';
import type { ReactNode, TransitionEvent } from 'react';

interface NotificationCardFrameProps {
  /** `true` enquanto o card anima a saída (dismiss). Mantém o nó montado até o transitionend. */
  isExiting: boolean;
  /** O card cola no painel direito de 440px; quando ele colapsa, desliza para a borda da viewport. */
  isRightPanelHidden: boolean;
  onTransitionEnd: (event: TransitionEvent<HTMLDivElement>) => void;
  children: ReactNode;
}

// Moldura genérica do card flutuante: posiciona (canto inferior-direito, acompanhando o painel) + anima
// entrada/saída. O conteúdo é o card compartilhado do tipo.
const NotificationCardFrame = ({ isExiting, isRightPanelHidden, onTransitionEnd, children }: NotificationCardFrameProps) => (
  <div
    className={cn(
      'fixed bottom-4 z-[1003] w-[352px] max-w-[calc(100vw-2rem)] transition-[opacity,transform,right] duration-200 ease-out motion-reduce:duration-[1ms]',
      isRightPanelHidden ? 'right-4' : 'right-[calc(440px+1rem)]',
      isExiting && 'pointer-events-none translate-y-2 scale-[0.98] opacity-0'
    )}
    onTransitionEnd={onTransitionEnd}
  >
    {children}
  </div>
);

export default NotificationCardFrame;
